import { random } from "lodash";
import { getToken } from "@/CommonDP/utils/index.js";
import { isDef } from "@/CommonDP/utils/common";
import globalParams from "@/CommonDP/utils/globalParams.js";
//是否忽略菜单权限
const ignorePermissionCheck = false;

export function baseUrl() {
  return location.origin + process.env.VUE_APP_API;
}

export function baseUrlWeb() {
  if(process.env.VUE_APP_MODE==='hash'){
    return baseUrl() +"/#"
  }else{
    return baseUrl()
  }

}

export function Permi() {
  return ignorePermissionCheck;
}


export function questionImgUrl(prjId, fileMD5) {
  return (
    location.origin +
    `/bim/doc/v1/wopi/download/drawing?prjId=${prjId}&fileMd5=${fileMD5}&token=${getToken()}`
  );
}

export function getReadImgFile(filePath) {
  return (
    location.origin + `/bim/doc/v1/upload/` + filePath + "?token=" + getToken()
  );
}

export function downsubway() {
  return location.origin + `/bim/doc/v1/subway/download?token=${getToken()}`;
}
// 文件预览
export function scanUrl(fileId, version) {
  return (
    process.env.VUE_APP_API +
    `/wopi/download/file/content?fileId=${fileId}&version=${version}&token=${getToken()}`
  );
}

export function scanModelUrl(filePath) {
  return location.origin + `/bim/doc/v1/view/${filePath}?token=${token()}`;
}

export function prjImgUploadUrl(filePath) {
  return location.origin + `/bim/doc/v1/upload/${filePath}?token=${getToken()}`;
}

export function scanUrlgml(fileId, docVersionId = "") {
  return (
    location.origin +
    `/bim/doc/v1/wopi/download/file/content-gml?fileId=${fileId}&docVersionId=${docVersionId}&token=${getToken()}`
  );
}

export function viewOfficeUrl(fileId) {
  return (
    baseUrl() + `/wopi/getWopiClientUri?fileId=${fileId}&isEdit=false&token=${getToken()}`
  );
}

export function randomStr(length) {
  // 获取随机字符串
  var list = Array.from({ length }, () => {
    return String.fromCharCode(
      Math.random() > 0.5 ? random(65, 90) : random(65, 90)
    );
  }).join("");
  return list;
}

export function showPrjName() {
  return new Set(["design"]);
}
//判断访问来源
export function isMobile() {
  var mobile = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return mobile != null;
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf("?") + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * @description 加载一个script,返回一个Promise对象
 * @param {string} src   url
 * @returns {Promise}
 */
export const importScript = async (href = "") => {
  return href
    ? new Promise((resolve, reject) => {
        let el;
        const src = new URL(href, window.location).href;
        // 是否已经加载此js
        const oldScript = document.querySelector(`script[src="${src}"]`);
        if (oldScript) {
          el = oldScript;
        } else {
          el = document.createElement("script");
          el.src = src;
          el.type = "text/javascript";
          document.head.appendChild(el);
        }
        // js加载已完成
        const isloadend = el.dataset.load === "end";
        if (isloadend) {
          resolve();
        } else {
          el.addEventListener("load", () => {
            el.dataset.load = "end";
            resolve();
          });
          el.addEventListener("error", () => {
            document.head.removeChild(el);
            reject();
          });
        }
      })
    : Promise.reject();
};

export function baseApi() {
  return process.env.VUE_APP_API;
}

export function gentlyUrl(versionId, rvtId, prjId) {
  return (
    baseApi() +
    `/halo/api/app-doc-center/v1/upload-zip?versionId=${versionId}&rvtId=${rvtId}&prjId=${prjId}&token=${token}`
  );
}

/* istanbul ignore next */
export const on = (function () {
  if (document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent("on" + event, handler);
      }
    };
  }
})();

/* istanbul ignore next */
export const off = (function () {
  if (document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent("on" + event, handler);
      }
    };
  }
})();

export function rafThrottle(fn) {
  let locked = false;
  return function (...args) {
    if (locked) return;
    locked = true;
    window.requestAnimationFrame((_) => {
      fn.apply(this, args);
      locked = false;
    });
  };
}

export const isFirefox = function () {
  return !!window.navigator.userAgent.match(/firefox/i);
};

export const uploadFileFolder = baseApi() + "/doc/chunk";
// 上传附件地址
export function uploadDataUrl() {
  return baseApi() + `/common/upload`;
}
export function questionImgUrl1(fileMD5) {
  return (
    process.env.VUE_APP_API +
    `/pic/preview/${fileMD5}?token=${getToken()}`
  );
}
//内部人员下载导入模板
export function downloadTemplate(token) {
  return (
    process.env.VUE_APP_API +
    `/import-staff/downloadTemplate?token=${getToken()}`
  );
}

//成员管理下载导入模板
export function downloadSupplierTemplate(token) {
  return (
    process.env.VUE_APP_API +
    `/supplier-org/manage/invite/downloadTemplate?token=${getToken()}`
  )
}

// 文件预览
export function viewFile(filePath, token) {
  return process.env.VUE_APP_API + `/view/${filePath}?token=${token}`;
}
export function prjplantaskexportexcel(prjId,conPlanId) {
  // 导出
  return (
    process.env.VUE_APP_API +
    `/lc/prj-plan-task/export-excel?prjId=${prjId}&conPlanId=${conPlanId}&token=${getToken()}`
  );
}
// 获取头像
export function gettouxAvatar(data) {
  return (
    process.env.VUE_APP_API + `/pic/avatar/${data}?token=${getToken()}`
  );
}
export function downloadUrlone(fileId) {
  return (
    process.env.VUE_APP_API + `/download/${fileId}?token=${getToken()}`
  );
}
export function downloadUrltoken(prjId, fileId) {
  return (
    process.env.VUE_APP_API +
    `/doc/download/${prjId}/${fileId}?token=${getToken()}`
  );
}
export function shareDownloadUrl(prjId, fileId) {
  return (
    process.env.VUE_APP_API +
    `/doc/download/${prjId}/${fileId}?token=${getToken()}`
  );
}
// app文件预览
export function scanUrlapp(fileId) {
  return (
    process.env.VUE_APP_API +
    `/app/download/file/content?fileId=${fileId}`
  );
}
export function getapptoux(data) {
  return process.env.VUE_APP_API + `/app/avatar?userId=${data}`;
}
// 反馈统计附件预览
export function feedBackPreviewAccessory(questionID) {
  return (
    process.env.VUE_APP_API +
    `/feedback/browse?questionID=${questionID}&token=${getToken()}`
  );
}
export function downloadUrl(prjId, fileId) {
  // 自定义接口地址
  const newUrl = globalParams.get("url:/doc/download/${prjId}/${fileId}");
  if (isDef(newUrl)) {
    return process.env.VUE_APP_API + `${newUrl}/${prjId}/${fileId}?token=${getToken()}`;
  }
  return process.env.VUE_APP_API + `/doc/download/${prjId}/${fileId}?token=${getToken()}`;
}
//模型缩略图
export function modelThumbnail(fileId,fileVersion) {
  return (
    process.env.VUE_APP_API +
    `/light/preview/thumbnail?fileId=${fileId}&fileVersion=${fileVersion}&token=${getToken()}`
  )
}
//内部人员下载导入模板
export function downloadPlanTemplate(token) {
  return (
    process.env.VUE_APP_API +
    `/constructionPlan/downloadTemplate?token=${getToken()}`
  );
}

export function downloadBlob(blob,fileName){
  if ("msSaveOrOpenBlob" in navigator) {
    window.navigator.msSaveOrOpenBlob(blob, fileName);
    return;
  } else {
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", decodeURI(fileName));
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}